import {Component, 
    OnInit, 
    ElementRef, 
    ViewChildren, 
    ViewChild, 
    ChangeDetectionStrategy, 
    ChangeDetectorRef, 
    Inject, 
	ViewRef
} 
from '@angular/core';
import { DatePipe } from '@angular/common';
import moment from 'moment';
// Material
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatTabChangeEvent, MatTabGroup, MatTab, MatTabHeader } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
// RXJS
import { ReplaySubject,BehaviorSubject } from 'rxjs';
//DataSource
import { SoDoKhoDataSource } from '../so-do-kho-datasource/so-do-kho.datasource';
//Service
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';
import { SoDoKhoService } from '../so-do-kho-service/so-do-kho.service';
import { LayoutUtilsService, MessageType } from '../../../../../../core/_base/crud';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
//Model
import { CommonConFig } from 'app/views/pages/nfc/dung-chung/__model/common_config.model';
import { KhuVucKho } from '../so-do-kho-model/so-do-kho.model';
import { KhoModel } from '../../../kho/kho-model/kho.model';

@Component({
	selector: 'm-so-do-kho-view-dialog',
	templateUrl: './so-do-kho-view-dialog.component.html',
	styleUrls: ['../so-do-kho.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers:[DatePipe]
})

export class SoDoKhoViewComponent implements OnInit{

    /*Config Form */
    CONFIG: CommonConFig;

    // Table fields
    dataSource: SoDoKhoDataSource;

    displayedColumns = [];
    availableColumns = [];

    displayedTangColumns = [];
    availableTangColumns = [
        {
            stt: 1,
            name: 'Tang',
            isShow: true
        }
    ];

    // Selection
    selectedColumns = new SelectionModel<any>(true, this.availableColumns);
    selectedTangColumns = new SelectionModel<any>(true, this.availableTangColumns);

    loadingSubject = new BehaviorSubject<boolean>(false);
    loading$ = this.loadingSubject.asObservable();

    rongSaver:any[] = [];
    daiSaver:any[] = [];
    caoSaver:any[] = [];
    tangRevert:any[] = [];
    numberOfTang:any [] =[];
    kvkSaver2d: KhuVucKho[][] = [[]];
    SelectedItem: KhuVucKho[] = [];
    SelectedItemVer2: KhuVucKho;
    ListViTriKho: string[];

    khoModel: KhoModel;
    flagSubmit: boolean = true;
    flagLeftClickObject: KhuVucKho[] = [];
    KhuVucSaver:any[] = [];
    SelectedTangItem: any;
    valuePosition: string = '';

    /* Extend field:  */
	title: string = '';					// Tiêu đề dialog
	viewLoading: boolean = false;   	// Loading khi mở dialog
    /* ------------------------------------------------------------------ */

    constructor(
		public dialogRef: MatDialogRef<SoDoKhoViewComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
        private soDoKhoService: SoDoKhoService,
        private dungChungService: DungChungService,
		public dialog: MatDialog,
		private tokenStorage: TokenStorage,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
    ) { 
		this.dialogRef.disableClose = true;
    }

    /*---------------------------- LOAD DATA --------------------------------*/
    ngOnInit() {
        /*Load cấu hình config form */
        this.CONFIG = new CommonConFig();

        /*Get data from list when open dialog */
		this.khoModel = this.data.data;
     
        /*Load title of dialog */
        this.title = this.getTitle();
        this.getDS_ViTriKho_Empty(this.khoModel.Id_Kho);
        this.resetKhuHangSaver();
        this.loadSoDoKho(this.khoModel)

        /*Handel keydown event in dialog*/
		this.dialogRef.keydownEvents().subscribe(event => {
			if (event.key == "Escape") {
				this.back(0);
			}
			this.changeDetectView();
        });
    }
    /* -----------------------------------------------------------------------*/

    /*----------------- Create Form with appropriate sub forms ---------------*/
    getTitle(): string {
		return 'Sơ đồ kho';
    }
    /* -----------------------------------------------------------------------*/


    /*-------- CÁC HÀM HỖ TRỢ CHUYỂN CỘT VÀ HIỂN THỊ CỘT TRONG BẢNG ----------*/
    showColumnsInTable() {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].isShow == false) {
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
    }
    applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for (let i = 0; i < this.availableColumns.length; i++) {
			this.selectedColumns.toggle(this.availableColumns[i]);
			for (let j = 0; j < _selectedColumns.length; j++) {
				if (this.availableColumns[i].name == _selectedColumns[j].name) {
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
    }
    showColumnsTangInTable() {
		for (let i = 0; i < this.availableTangColumns.length; i++) {
			if (this.availableTangColumns[i].isShow == false) {
				this.selectedTangColumns.toggle(this.availableTangColumns[i]);
			}
		}
    }
    applySelectedTangColumns() {
		let _selectedColumns = this.selectedTangColumns.selected;
		this.selectedTangColumns = new SelectionModel<any>(true, this.availableTangColumns);
		for (let i = 0; i < this.availableTangColumns.length; i++) {
			this.selectedTangColumns.toggle(this.availableTangColumns[i]);
			for (let j = 0; j < _selectedColumns.length; j++) {
				if (this.availableTangColumns[i].name == _selectedColumns[j].name) {
					this.selectedTangColumns.toggle(this.availableTangColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedTangColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedTangColumns = _applySelectedColumns;
	}
    /* -----------------------------------------------------------------------*/


    /*---------------------------- Thao tác trên form ------------------------*/
    changeDetectView(){
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}
    back(type: number){
		this.dialogRef.close({ 
			vitrikho : type == 0 ? '' : this.valuePosition
		});
    }
    /* -----------------------------------------------------------------------*/

    /*----------------------- Hàm xử lý sự kiện click ------------------------*/
    clickEvent(row: number, column: number){
        if(this.kvkSaver2d[row][column].TuHang > 0 && this.kvkSaver2d[row][column].TuCot > 0){

            this.checkStoreClickObject();
            this.flagLeftClickObject.push(this.kvkSaver2d[row][column]);

            this.kvkSaver2d[row][column].isSelect = !this.kvkSaver2d[row][column].isSelect
            if(this.kvkSaver2d[row][column].isSelect && this.kvkSaver2d[row][column].TuHang >= 0 && this.kvkSaver2d[row][column].TuCot >= 0){
                this.SelectedItem.push(this.kvkSaver2d[row][column]);
            }
            else if(!this.kvkSaver2d[row][column].isSelect && this.kvkSaver2d[row][column].TuHang >= 0 && this.kvkSaver2d[row][column].TuCot >= 0){
                for(let i = 0; i < this.SelectedItem.length; i++){
                    if(this.SelectedItem[i] === this.kvkSaver2d[row][column]){
                        this.SelectedItem.splice(i,1);
                        break;
                    }
                }
            }
        }   
    }
    clickEventV2(row: number, column: number){
        if(this.kvkSaver2d[row][column].TuHang > 0 && this.kvkSaver2d[row][column].TuCot > 0){

            this.checkStoreClickObject();
            this.flagLeftClickObject.push(this.kvkSaver2d[row][column]);

            this.kvkSaver2d[row][column].isSelect = !this.kvkSaver2d[row][column].isSelect
            if(this.kvkSaver2d[row][column].isSelect && this.kvkSaver2d[row][column].TuHang >= 0 && this.kvkSaver2d[row][column].TuCot >= 0){
                if(this.SelectedItemVer2 != null){
                    this.SelectedItemVer2.isSelect = !this.SelectedItemVer2.isSelect
                }
                this.SelectedItemVer2 = this.kvkSaver2d[row][column]
                this.XemViTriKho();
            }
            else if(!this.kvkSaver2d[row][column].isSelect && this.kvkSaver2d[row][column].TuHang >= 0 && this.kvkSaver2d[row][column].TuCot >= 0){
                this.SelectedItemVer2 = null;
            }
        }   
    }
    checkStoreClickObject(){
        if(this.flagLeftClickObject.length == 2)
            this.flagLeftClickObject.splice(0,1);
    }
    selectTang(index: number){

        this.numberOfTang[index].isSelect = !this.numberOfTang[index].isSelect
        if(this.numberOfTang[index].isSelect){
            if(this.SelectedTangItem != null){
                this.SelectedTangItem.isSelect = !this.SelectedTangItem.isSelect
            }
            this.SelectedTangItem =  this.numberOfTang[index]
            this.valuePosition = this.pad(this.SelectedItemVer2.TuHang,3) + '.' + this.pad(this.SelectedItemVer2.TuCot,3) + '.' + this.pad(this.tangRevert[index],2)
        }
        else if(!this.numberOfTang[index].isSelect){
            this.SelectedTangItem = null;
            this.valuePosition = '';
        }

        this.changeDetectView();
    }
    /* -----------------------------------------------------------------------*/

    /*------------------------- Hàm xử lý dữ liệu ----------------------------*/
    pad(str: any, max: any) {
        str = str.toString();
        return str.length < max ? this.pad("0" + str, max) : str;
    }
    loadSoDoKho(item: KhoModel){
        this.soDoKhoService.loadDataKV(item.Id_Kho).subscribe(res => {
            if (res && res.status === 1) {
               
                this.availableColumns = [];
                this.caoSaver = [];
                this.daiSaver = [];
                this.rongSaver = [];
                
                for(let i = 1; i <= item.Tang; i++)
                    this.caoSaver.push(i);   

                let _listDataRes = res.data

                _listDataRes.forEach(element => {
                    let _indexCot = this.rongSaver.findIndex(x => x == element.DenHang)
                    if(_indexCot == -1){
                        this.rongSaver.push(element.DenHang)
                    }

                    let _indexHang = this.daiSaver.findIndex(x => x == element.DenCot)
                    if(_indexHang == -1){
                        this.daiSaver.push(element.DenCot)
                    }

                    let _indexKhuHang = this.KhuVucSaver.findIndex(x => x.color == element.MaMau)
                    if(_indexKhuHang == -1){
                        this.KhuVucSaver.push({
                            name: element.MaKhuVuc,
                            color: element.MaMau
                        });
                    }
                });

                this.caoSaver = this.caoSaver.sort((a,b) => a - b); 
                this.daiSaver = this.daiSaver.sort((a,b) => a - b); 
                this.rongSaver = this.rongSaver.sort((a,b) => a - b); 

                for(let i = 0; i < this.daiSaver.length; i++){
                    this.daiSaver[i] += 1;
                    this.availableColumns.push({
                        stt: this.daiSaver[i],
                        name: '' + this.daiSaver[i],
                        isShow: true
                    })
                }
                
                
                this.kvkSaver2d = [];
                for(let i = 0; i < this.rongSaver.length; i++){
                    this.kvkSaver2d[i] = [];

                    let _arrayRow =  _listDataRes.filter(x => x.DenHang == this.rongSaver[i])
                    _arrayRow.sort(function(a, b){return a.DenCot - b.DenCot});

                    for(let j = 0; j < _arrayRow.length; j++) {
                        let objectTmp = new KhuVucKho();
                        objectTmp.copy(_arrayRow[j]);
                        this.kvkSaver2d[i][j] = objectTmp;
                    }
                    this.rongSaver[i] += 1;
                }
                
                this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
        
                this.showColumnsInTable();
                this.applySelectedColumns();
                this.changeDetectView();
            }
            else {
                this.layoutUtilsService.showActionNotification('Lỗi load dữ liệu sơ đồ kho', MessageType.Delete);
            }
        });
    }
    resetThietLap(){
        this.rongSaver = [];
        this.daiSaver = [];
        this.caoSaver = [];
        this.resetKhuHangSaver();
        this.changeDetectView();
    }
    resetKhuHangSaver(){
        this.KhuVucSaver = [];
        this.KhuVucSaver.push(
            {
                name: 'Vị trí trống',
                color: KhuVucKho.defaultColor.CLEAR
            },
            {
                name: 'Đường đi',
                color: KhuVucKho.defaultColor.ROAD
            },
            {
                name: 'Vị trí không được lưu kho',
                color: KhuVucKho.defaultColor.NOT_SAVE
            },
           
        );
    }
    checkDuongDi(item: KhuVucKho){
        return (item.TuHang < 0 && item.TuCot < 0)
    }
    getDS_ViTriKho_Empty(IdKho: number){
		let listVTK_Empty = [];
		let listVTK_Full = [];
		let hKho = 1, hKhoMax = 0;
		let cKho = 1, cKhoMax = 0;
		let tKho = 1, tKhoMax = 0;
		this.dungChungService.getDSVTK(IdKho).subscribe(res => {
			if(res && res.status == 1){
				listVTK_Full = res.data.listVTK;
				hKhoMax = res.data.hKho;
				cKhoMax = res.data.cKho;
				tKhoMax = res.data.tKho;
				for(let t = tKho; t <= tKhoMax; t++){
					for(let c = cKho; c <= cKhoMax; c++){
						for(let h = hKho; h <= hKhoMax; h++){
							let value = this.pad(h,3)+"."+this.pad(c,3)+"."+this.pad(t,2);
							if(listVTK_Full.findIndex(x => x == value) == -1){
								listVTK_Empty.push(value);
							}
						}
					}
                }
                this.ListViTriKho = listVTK_Empty
			}
		});
    }
    XemViTriKho(){
        if(this.SelectedItemVer2 != null){
            this.numberOfTang = [];
            this.tangRevert = [];
            this.caoSaver.forEach(element =>{
                let tmp = new KhuVucKho();
                tmp.copy(this.SelectedItemVer2)
                tmp.isSelect = false;
                this.numberOfTang.push(tmp);
                this.tangRevert.push(element);
            })
            this.tangRevert.reverse();
            this.numberOfTang.reverse();
            this.numberOfTang = [...this.numberOfTang];
            this.applySelectedTangColumns();
            this.showColumnsTangInTable();
            this.changeDetectView();
        }
        else{
            this.layoutUtilsService.showActionNotification('Vui lòng chọn vị trí để xem chi tiết!', MessageType.Delete);
        }
    }
    fieldColorDaCoViHang(viTriTang: string){
        if(viTriTang != null && viTriTang != undefined){
            let formatPosition = this.pad(this.SelectedItemVer2.TuHang,3) + '.' + this.pad(this.SelectedItemVer2.TuCot,3) 
            let filterListViTri = this.ListViTriKho.filter(x => x.indexOf(formatPosition) > -1)
            let _index = filterListViTri.findIndex(x => x == formatPosition + '.' + viTriTang)
    
            return _index > -1;
        }
       
        return false;
    }
    /* -----------------------------------------------------------------------*/

}